import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'sampleReception',
  components: {
    datetime: Datetime,
    DateTime,
    VanishingTableSelection: require('../../../../customcontrols/vanishingTableSelection.vue').default,
    DualListPicker: require('../../../../customcontrols/dualListPicker.vue').default,
    //SelectAccount: require('../../../../customcontrols/selectAccount.vue').default,
    //SelectProperty: require('../../../../customcontrols/selectProperty.vue').default,
    findCustomerComp: require('../../../../customcontrols/findCustomer.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      currentTab: 'tab-log',
      currentTabDetails: 'sample-parmeters',
      freeStreet: true,
      customSamplerEnable: true,
      employeeDisplayString: "",
      parameterGroup: "",
      availableParameters: null,
      otherObesrvations: "",

      samplingPoints: [],
      samplingPointsConfig: {},
      samplingPointsPageingOption: {
        pageSize: 10, total: 0, page: 1
      },
      properties: [],
      selectedPropertyRef: "",
      propertiesConfig: {},
      propertiesPageingOption: {
        pageSize: 10, total: 0, page: 1
      },
      customersConfig: {},
      customersPageingOption: {
        pageSize: 10, total: 0, page: 1
      },
      samplingLocations: [],
      search: "",
      customers: [],
      selectedBillingGroup: '',

      bShowFindCustomer: false,

      custObj: {
        appId: 0,
        customer: null,
        showSelectedPanel: false,
        completeSelection: null,
        filterObj: [],
        billingGroups: [],
        bgValueField: 'value',
        bgTextField: 'text',
        customers: [],
      },
      customer: {
        customerKey: ''
      },

      streets: [],
      freeStreetInput: false
    }
  },
  created() {
    this.appId = this.dataObj.appId;
    this.samplingPointsConfigration();
    this.getSamplingPoints();
    //this.propertiesConfigration();
    //this.getProperties();
    this.customersConfigration();
    this.getCustomers();
    this.getStreets();
  },
  watch: {
    samplingPointId() {
      this.getSampleLocations();
    },
    customerKey() {
      this.getCustomerProperties();
    },
  },
  computed: {
    samplingPointId() {
      return this.dataObj.appData.sampleLog.samplingPointId;
    },
    customerKey() {
      return this.dataObj.appData.customerDetails.customerKey;
    }
  },

  methods: {
    alert(str) {
      window.alert(str);
    },
    searchFunc(str) {
      alert(str);
    },
    changeTab(e) {
      this.currentTab = e;
    },
    changeTabDetails(e) {
      this.currentTabDetails = e;
    },


    getProperties(id = '', pageOpt = null) {

      var opt = {};

      if (pageOpt == null) {
        opt = {
          Page: this.propertiesPageingOption.page,
          PageSize: this.propertiesPageingOption.pageSize
        };
      } else {
        opt = pageOpt;
      }

      const fil = {
        PropertyOwnerCustomerKey: id
      };
      const options = {
        Filters: fil,
        Options: opt
      };

      axios.post('/SampleReceptionActivity/GetProperties', options)
        .then(response => {
          if (response.status == 200) {
            this.properties = response.data.items;
            this.propertiesConfig['totalRows'] = response.data.itemsCount;
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },

    propertiesConfigration() {
      this.propertiesConfig['keyColumn'] = 'propertyId';
      this.propertiesConfig['pageOptions'] = this.propertiesPageingOption;
      this.propertiesConfig['cols'] = [];
      this.propertiesConfig['cols'].push({ dataField: 'propertyReference', caption: this.$t('lims.propReference') });
      this.propertiesConfig['cols'].push({ dataField: 'tenantCustomerKey', caption: this.$t('lims.propTenant') });
      this.propertiesConfig['cols'].push({ dataField: 'tenantName', caption: this.$t('lims.propTenantName') });
      this.propertiesConfig['cols'].push({ dataField: 'tenantTelephoneNumber', caption: this.$t('lims.telNo') });
      this.propertiesConfig['cols'].push({ dataField: 'tenantIdNumber', caption: this.$t('lims.idNo') });
      this.propertiesConfig['cols'].push({ dataField: 'propertyAddress', caption: this.$t('lims.addressCustomer') });
      this.propertiesConfig['cols'].push({ dataField: 'propertyBuldingName', caption: this.$t('lims.buildingName') });
      this.propertiesConfig['cols'].push({ dataField: 'propertyOwnerName', caption: this.$t('lims.propOwnerName') });
      this.propertiesConfig['cols'].push({ dataField: 'propertyOwnerCustomerKey', caption: this.$t('lims.propOwner') });
      this.propertiesConfig['cols'].push({ dataField: 'ownerShare', caption: this.$t('lims.ownerShare') });
      this.propertiesConfig['cols'].push({ dataField: 'propertyOwnerIdNumber', caption: this.$t('lims.ownerIdNo') });
      this.propertiesConfig['cols'].push({ dataField: 'propertyOwnerTelephoneNumber', caption: this.$t('lims.ownerTel') });
      this.propertiesConfig['cols'].push({ dataField: 'propertyOwnerCellPhoneNumber', caption: this.$t('lims.ownerCell') });
    },
    getCustomers(billGroup = '', pageOpt = null) {
      this.selectedBillingGroup = billGroup;
      //console.log('biil grp: ' + billGroup);
      //console.log(pageOpt);
      var opt = {
        Page: this.customersPageingOption.page,
        PageSize: this.customersPageingOption.pageSize
      };

      if (pageOpt != null)
        opt = pageOpt;

      var fil;
      if (billGroup != '') {
        fil = {
          BillingGroup: billGroup
        };
      } else fil = {};

      const options = {
        Filters: fil,
        Options: opt
      };

      axios.post('/SampleReceptionActivity/GetCustomers', options)
        .then(response => {
          if (response.status == 200) {
            this.customers = response.data.items;
            this.customersConfig['totalRows'] = response.data.itemsCount;
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });

    },

    customersConfigration() {
      this.customersConfig['keyColumn'] = 'customerKey';
      this.customersConfig['pageOptions'] = this.customersPageingOption;
      this.customersConfig['cols'] = [];
      this.customersConfig['cols'].push({ dataField: 'billingGroup', caption: this.$t('lims.group') });
      this.customersConfig['cols'].push({ dataField: 'customerKey', caption: this.$t('lims.account') });
      this.customersConfig['cols'].push({ dataField: 'surname', caption: this.$t('lims.surname') });
      this.customersConfig['cols'].push({ dataField: 'address', caption: this.$t('lims.addressCustomer') });
      this.customersConfig['cols'].push({ dataField: 'consumerTypeStr', caption: this.$t('lims.consumerType') });
      this.customersConfig['cols'].push({ dataField: 'telephoneNumber', caption: this.$t('lims.telNo') });
      this.customersConfig['cols'].push({ dataField: 'idNumber', caption: this.$t('lims.idNo') });
      this.customersConfig['cols'].push({ dataField: 'workTelNo', caption: this.$t('lims.cellPhone') });
    },

    getSamplingPoints(options) {
      axios.get('/LimsActivityBase/GetSamplingPoints?page=' + this.samplingPointsPageingOption.page + '&pageSize=' + this.samplingPointsPageingOption.pageSize)
        .then(response => {
          if (response.status == 200) {
            this.samplingPoints = response.data.items;
            this.samplingPointsConfig['totalRows'] = response.data.itemsCount;
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    samplingPointsConfigration() {
      this.samplingPointsConfig['keyColumn'] = 'id';
      this.samplingPointsConfig['pageOptions'] = this.samplingPointsPageingOption;
      this.samplingPointsConfig['cols'] = [];

      this.samplingPointsConfig['cols'].push({ dataField: 'description', caption: this.$t('lims.samplingPoint') });
    },
    getSampleLocations() {
      axios.get('/LimsActivityBase/GetSampleLocations?samplingPointId=' + this.dataObj.appData.sampleLog.samplingPointId)
        .then(response => {
          if (response.status == 200) {
            this.samplingLocations = response.data;

            if (this.samplingLocations.length == 0) {
              this.dataObj.appData.sampleLog.locationId = 0;
            } else {
              if (this.samplingLocations.filter(a => a.selected).length == 0)
                this.dataObj.appData.sampleLog.locationId = this.samplingLocations[0].value;
              else
                this.dataObj.appData.sampleLog.locationId = this.samplingLocations.filter(a => a.selected)[0].value;
            }
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    addParameters: function (stndrAnalysis) {
      alert(stndrAnalysis);
    },
    addQualityTemplateElements() {
      axios.get('/LimsActivityBase/GetQualityTemplateFields?qualityTemplateId=' + this.dataObj.appData.qualityTemplateId)
        .then(response => {
          if (response.status == 200) {
            for (var i = 0; i < response.data.length; i++) {
              if (this.dataObj.appData.sampleFieldIds.filter(a => a == response.data[i].id).length == 0) {
                this.dataObj.appData.sampleFieldIds.push(response.data[i].id);
              }
            }
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    getStreetsElements() {
      axios.get('/LimsActivityBase/GetStreets?')
        .then(response => {
          if (response.status == 200) {
            for (var i = 0; i < response.data.length; i++) {
              if (this.dataObj.appData.sampleFieldIds.filter(a => a == response.data[i].id).length == 0) {
                this.dataObj.appData.sampleFieldIds.push(response.data[i].id);
              }
            }
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    addProperty(obj) {

      //console.log(obj);
      this.selectedPropertyRef = obj.propertyReference;
    },

    validateAppData() {
      return true;
    },
    showFindCustomer() {

      if (this.dataObj.readOnly)
        return;

      this.custObj.appId = this.appId;
      this.custObj.customer = this.customer;
      this.custObj.completeSelection = this.selectCustomerDone;
      this.custObj.billingGroups = this.dataObj.billingGroups;
      this.bShowFindCustomer = true;
      this.$emit('find_customer_updated');
    },
    selectCustomerDone(custkey) {
      this.bShowFindCustomer = false;
      this.customer = this.custObj.customer;

      if (!this.customer)
        return;

     // console.log(this.customer);

      this.dataObj.appData.customerDetails.surname = this.customer.surname;
      this.dataObj.appData.customerDetails.customerKey = this.customer.customerKey;
      this.dataObj.appData.customerDetails.telephoneNumber = this.customer.telephoneNumber;
      this.dataObj.appData.customerDetails.cellPhone = this.customer.cellPhone;
      this.dataObj.appData.customerDetails.faxNo = this.customer.faxNo;
      this.dataObj.appData.customerDetails.workTelNo = this.customer.workTelNo;
      this.dataObj.appData.customerDetails.email = this.customer.email;
      this.dataObj.appData.customerDetails.billingGroup = this.customer.billingGroup;
      this.dataObj.appData.customerDetails.billingGroupStr = this.customer.billingGroupStr;
      this.dataObj.appData.customerDetails.address = this.customer.address;
      this.dataObj.appData.customerDetails.houseNo = this.customer.houseNo;
      this.dataObj.appData.customerDetails.flatNo = this.customer.flatNo;
    },



    getCustomerProperties() {
      var parameters = {
        options: {
          Page: 1,
          PageSize: 10,
          FilterText: ''
        },
        Filters: {
          PropertyOwnerCustomerKey: this.dataObj.appData.customerDetails.customerKey,
        }
      };

      axios.post('/SampleReceptionActivity/GetProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            //console.log(response);

            this.properties = response.data.items;

            if (this.properties.length > 0)
              this.dataObj.appData.propertyId = this.properties[0].propertyId;
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
    getStreets() {
      var parameters = {
        options: {
          Page: 1,
          PageSize: 10,
          FilterText: ''
        },
        Filters: {
          PropertyOwnerCustomerKey: this.dataObj.appData.customerDetails.customerKey,
        }
      };

      axios.get('/SampleReceptionActivity/GetStreets')
        .then(response => {
          if (response.status == 200) {
            //console.log(response);

            this.streets = response.data;
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });
    },
  },
}
